<template>
  <div class="mainContent">
    <img :src="image[$i18n.locale]" />
  </div>
</template>

<script>
const imageZh = require('@/assets/image/other/about-zh.jpg');
const imageEn = require('@/assets/image/other/about-en.jpg');

export default {
  name: 'about',
  data() {
    return {
      image: {
        zh: imageZh,
        en: imageEn,
      },
    };
  },
};
</script>
<style lang="sass" scoped>
@import '../../assets/css/mixins'

.mainContent
  min-height: 300px
  @include base-wrap
  overflow: hidden

</style>
<style scoped lang="scss">
.mainContent {
  img {
    width: 100%;
  }
}
</style>
